import React, { useCallback } from 'react';
import { AnyObject } from 'final-form';
import cn from 'classnames';
import { useField } from 'react-final-form';
import TextTruncate from 'react-text-truncate';

import { createFormField } from 'Shared/utils/createFormField';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';
import WpIcon from 'Wpds/components/icon/WpIcon';

import './index.scss';

function MobileRecurringMeeting({ value: recurringMeeting, name }: AnyObject) {
  const {
    input: { onChange: onSelectedChange },
  } = useField(`${name}.selected`);

  const handleClick = useCallback(
    () => onSelectedChange(!recurringMeeting.selected),
    [onSelectedChange, recurringMeeting.selected]
  );

  if (!recurringMeeting) return null;

  return (
    <div
      className={cn('MobileRecurringMeeting d-flex w-100 mb-3 cursor-pointer', {
        'MobileRecurringMeeting--selected': recurringMeeting.selected,
      })}
      onClick={handleClick}
    >
      <div className="d-flex w-100">
        <StyledCheckbox
          className="MobileRecurringMeeting__checkbox"
          checked={recurringMeeting.selected}
          onChange={() => null}
        />
        <div className="mr-2 w-100">
          <div className="MobileRecurringMeeting__title">
            <TextTruncate line={2} truncateText="…" text={recurringMeeting.name} />
          </div>

          {recurringMeeting.frequency && (
            <div className="MobileRecurringMeeting__info MobileRecurringMeeting__info--break-word">
              {recurringMeeting.frequency}
            </div>
          )}
        </div>
      </div>
      <div className="MobileRecurringMeeting__calendar-icon align-items-end">
        <WpIcon name="calendar" />
      </div>
    </div>
  );
}

export default createFormField(MobileRecurringMeeting);
